import { datadogRum } from '@datadog/browser-rum';

type RumProduct = 'db-search' | 'registry' | 'platform';

/**
 * Maps URL pathname to a product area for RUM filtering. Route groups like (public)
 * are not visible in the pathname — use path segments only.
 */
function rumProductFromPathname(pathname: string): RumProduct {
  if (pathname.includes('/registry')) {
    return 'registry';
  }
  if (
    /^\/[^/]+\/(animals|members|sales|search)(\/|$)/.test(pathname) ||
    /^\/[^/]+\/external(\/|$)/.test(pathname)
  ) {
    return 'db-search';
  }
  return 'platform';
}

/** Sets @context.product on RUM (and forwarded traces) when Datadog is initialised. */
export function applyRumProductFromPathname(pathname: string): void {
  if (typeof window === 'undefined' || !datadogRum.getInitConfiguration()) {
    return;
  }
  datadogRum.setGlobalContextProperty(
    'product',
    rumProductFromPathname(pathname),
  );
}
